"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeFilesToScannedProjects = void 0;
const node_1 = require("./node");
Object.defineProperty(exports, "nodeFilesToScannedProjects", { enumerable: true, get: function () { return node_1.nodeFilesToScannedProjects; } });
//# sourceMappingURL=index.js.map